// Everything the in-game Save the Date card says. The visible card is
// public/save-the-date-card.svg (exported from Canva); these strings are
// read to screen readers and used for the calendar, so keep them in sync.
export const SAVE_THE_DATE = {
  headline: "We're getting married!",
  title: 'Save the date',
  partnerOne: 'Julie Kim',
  partnerTwo: 'Daniel Yu',
  date: 'June 11, 2027',
  place: 'Woodinville, WA',
  footer: 'Invitation to follow',
  // The four photo spots, in reading order: top right, middle left, bottom
  // left, bottom right. Files live in /public. `null` shows an empty spot.
  // `fadeTop` softens a photo whose top edge is cut off in the file.
  // They fill the Canva design's photo spots (see CardContent.tsx).
  photos: [
    { src: '/save-the-date-suits-still.webp' },
    { src: '/save-the-date-engaged.webp', fadeTop: true },
    { src: '/save-the-date-cuddle.webp', fadeTop: true },
    { src: '/save-the-date-upright-clear.webp' },
  ] as ({ src: string; fadeTop?: boolean } | null)[],
  // "Add to calendar". An all-day event until the ceremony time is set;
  // `end` is the day after (calendar all-day events end exclusively).
  // If you change these, update public/save-the-date.ics (Apple) to match.
  // Wedding website, linked from the button under the card.
  website: 'https://judni-wedding.pages.dev/',
  calendar: {
    title: "Julie & Daniel's Wedding",
    start: '2027-06-11',
    end: '2027-06-12',
    location: 'Woodinville, WA',
    details: 'Save the date! Wedding invitation to follow.',
  },
}
